module.exports = __webpack_public_path__ + "static/shxhyy-40071285d8a59e76d4939b8842e726a6.jpg";